module.exports = __webpack_public_path__ + "static/media/pullUp.95a533ac.svg";